import { CanActivateLogin } from '../services/canActivateLogin.service';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './signUp/signUp.component';
import { ResetPasswordComponent } from './resetPassword/resetPassword.component';
import { ConfirmResetPasswordComponent } from './confirmResetPassword/confirmResetPassword.component';
import { ActivateAccountComponent } from './activateAccount/activateAccount.component';
import { ContainerComponent } from './container/container.component';
import { EmailSignUpComponent } from './email-sign-up/email-sign-up.component';
import { MobileSignUpComponent } from './mobile-sign-up/mobile-sign-up.component';
import { EmailLogInComponent } from './email-log-in/email-log-in.component';
import { MobileLogInComponent } from './mobile-log-in/mobile-log-in.component';
import { ResetMobilePasswordComponent } from './reset-mobile-password/reset-mobile-password.component';

export const routes = [
  {
    path: 'account',
    children: [
      {
        path: 'reset',
        component: ResetPasswordComponent,
        canActivate: [CanActivateLogin],
      },
      {
        path: 'reset_mobile',
        component: ResetMobilePasswordComponent,
        canActivate: [CanActivateLogin],
      },
      {
        path: 'password/reset',
        component: ConfirmResetPasswordComponent,
        canActivate: [CanActivateLogin],
        data: {
          hideDefaultHeader: false,
        },
      },
      {
        path: 'activate',
        component: ActivateAccountComponent,
      },
      {
        path: 'login',
        component: ContainerComponent,
        children: [
          {
            path: '',
            component: LoginComponent,
            canActivate: [CanActivateLogin]
          },
          {
            path: 'email',
            component: EmailLogInComponent,
            canActivate: [CanActivateLogin]
          },
          {
            path: 'mobile',
            component: MobileLogInComponent,
            canActivate: [CanActivateLogin]
          },
        ]
      },
      {
        path: 'sign_up',
        component: ContainerComponent,
        children: [
          {
            path: '',
            component: SignUpComponent,
            canActivate: [CanActivateLogin],
          },
          {
            path: 'email',
            component: EmailSignUpComponent,
            canActivate: [CanActivateLogin],
          },
          {
            path: 'mobile',
            component: MobileSignUpComponent,
            canActivate: [CanActivateLogin],
          },
        ]
      }
    ]
  },
];
